module.exports = __webpack_public_path__ + "img/20200513_160935.79db73a9.jpg";